export default function Csharp1dArrays() {
  return (
    <h2>Csharp 1D Arrays</h2>
  );
}
